import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "feedback-main-container flex-center"
}
const _hoisted_2 = { class: "feedback-form flex-center" }
const _hoisted_3 = { class: "feedback-button-container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "heading flex-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header-2 feedback-header" }, "Feedback"),
  /*#__PURE__*/_createElementVNode("div", { class: "description feedback-description" }, "Help us improve your experience by giving us your feedback")
], -1 /* HOISTED */)
const _hoisted_5 = { class: "input-container flex-center" }
const _hoisted_6 = { class: "button-container flex-center" }
const _hoisted_7 = {
  key: 0,
  class: "loading-container flex-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.isLoggedIn)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "borderless close",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
            }, "Close")
          ]),
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode($setup["textfield"], {
              class: "name",
              label: "Name",
              modelValue: $setup.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.name) = $event))
            }, null, 8 /* PROPS */, ["modelValue"]),
            _createVNode($setup["TextField"], {
              class: "message",
              label: "Message",
              modelValue: $setup.response,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.response) = $event))
            }, null, 8 /* PROPS */, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              class: "primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.submitFeedbackEmail()))
            }, "Submit")
          ])
        ]),
        ($setup.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode($setup["loader"])
            ]))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}